import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ViewportScroller} from "@angular/common";
import {User} from "src/app/modules/auth/models/User";
import {ModalService} from "src/app/modules/core/services/modal.service";
import {NotificationsComponent} from "../notifications/notifications.component";
import {ProfileMenuComponent} from "../profile-menu/profile-menu.component";
import {TranslateModule} from "@ngx-translate/core";
import {DiscussionsButtonComponent} from "src/app/modules/discussions/components/discussions-button/discussions-button.component";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  host: {
    class:
      "transition-[z-index] duration-0 delay-300 has-[.notifications.submenu-open]:delay-0 has-[.notifications.submenu-open]:z-[95]!",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotificationsComponent,
    ProfileMenuComponent,
    TranslateModule,
    DiscussionsButtonComponent,
  ],
})
export class HeaderComponent {
  @Input() user?: User;

  constructor(
    public modalService: ModalService,
    private readonly viewport: ViewportScroller
  ) {}

  openModal(modalId: string) {
    this.modalService.openModal(modalId);
  }

  scrollToTop(event: Event) {
    if (
      !this.isProfileClick(event) &&
      !this.isAddWorkClick(event) &&
      !this.isSearchClick(event)
    ) {
      this.viewport.scrollToPosition([0, 0]);
    }
  }

  onKeyUp(event: KeyboardEvent, type: string): void {
    if (event.key === "Enter" || event.key === " ") {
      if (type === "scroll") {
        this.scrollToTop(event);
      } else {
        this.openModal(type);
      }
    }
  }

  isProfileClick(event: Event) {
    const target = event.target as HTMLElement;
    return !!target.closest(".profile");
  }

  isAddWorkClick(event: Event) {
    const target = event.target as HTMLElement;
    return !!target.closest(".add.btn-add");
  }

  isSearchClick(event: Event) {
    const target = event.target as HTMLElement;
    return !!target.closest(".search");
  }
}
